import React from 'react';
import {
  Router as DefaultRouter,
  Route,
  Switch,
  StaticRouter,
} from 'react-router-dom';
import dynamic from 'umi/dynamic';
import renderRoutes from 'umi/lib/renderRoutes';
import history from '@@/history';
import { routerRedux } from 'dva';

const Router = routerRedux.ConnectedRouter;

const routes = [
  {
    path: '/',
    component: require('../../layouts/index.js').default,
    routes: [
      {
        path: '/404',
        exact: true,
        component: require('../404.js').default,
        Author: 'DL',
        Date: '2020-12-10T12:49:05.000Z',
        Email: 'dunaliang@fengmap.com',
        LastEditTime: '2020-12-10T12:50:22.000Z',
        LastEditors: 'DL',
        Description: null,
        Copyright: 'Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.',
        _title: '诏安法院-智慧定位',
        _title_default: '诏安法院-智慧定位',
      },
      {
        path: '/home',
        exact: true,
        component: require('../home/index.js').default,
        Author: 'DL',
        Date: '2020-12-03T09:53:55.000Z',
        Email: 'dunaliang@fengmap.com',
        LastEditTime: '2020-12-18T12:06:51.000Z',
        LastEditors: 'DL',
        Description: null,
        Copyright: 'Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.',
        _title: '诏安法院-智慧定位',
        _title_default: '诏安法院-智慧定位',
      },
      {
        path: '/',
        exact: true,
        component: require('../index.js').default,
        Author: 'DL',
        Date: '2020-12-03T09:53:55.000Z',
        Email: 'dunaliang@fengmap.com',
        LastEditTime: '2020-12-04T18:34:57.000Z',
        LastEditors: 'DL',
        Description: null,
        Copyright: 'Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.',
        _title: '诏安法院-智慧定位',
        _title_default: '诏安法院-智慧定位',
      },
      {
        path: '/navi',
        exact: true,
        component: require('../navi/index.js').default,
        Author: 'DL',
        Date: '2020-12-04T23:33:30.000Z',
        Email: 'dunaliang@fengmap.com',
        LastEditTime: '2020-12-15T17:08:49.000Z',
        LastEditors: 'DL',
        Description: '起终点选择',
        Copyright: 'Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.',
        _title: '诏安法院-智慧定位',
        _title_default: '诏安法院-智慧定位',
      },
      {
        path: '/route',
        exact: true,
        component: require('../route/index.js').default,
        Author: 'DL',
        Date: '2020-12-06T14:56:03.000Z',
        Email: 'dunaliang@fengmap.com',
        LastEditTime: '2020-12-21T10:40:13.000Z',
        LastEditors: 'DL',
        Description: '路线搜索',
        Copyright: 'Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.',
        _title: '诏安法院-智慧定位',
        _title_default: '诏安法院-智慧定位',
      },
      {
        path: '/scheme',
        exact: true,
        component: require('../scheme/index.js').default,
        Author: 'DL',
        Date: '2020-12-06T14:18:36.000Z',
        Email: 'dunaliang@fengmap.com',
        LastEditTime: '2020-12-21T12:16:36.000Z',
        LastEditors: 'DL',
        Description: '路径规范',
        Copyright: 'Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.',
        _title: '诏安法院-智慧定位',
        _title_default: '诏安法院-智慧定位',
      },
      {
        path: '/search',
        exact: true,
        component: require('../search/index.js').default,
        Author: 'DL',
        Date: '2020-12-04T18:35:19.000Z',
        Email: 'dunaliang@fengmap.com',
        LastEditTime: '2020-12-13T00:27:42.000Z',
        LastEditors: 'DL',
        Description: '搜索页面',
        Copyright: 'Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.',
        _title: '诏安法院-智慧定位',
        _title_default: '诏安法院-智慧定位',
      },
      {
        path: '/select',
        exact: true,
        component: require('../select/index.js').default,
        Author: 'DL',
        Date: '2020-12-05T22:18:37.000Z',
        Email: 'dunaliang@fengmap.com',
        LastEditTime: '2020-12-18T11:33:54.000Z',
        LastEditors: 'DL',
        Description: '地图选择页面',
        Copyright: 'Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.',
        _title: '诏安法院-智慧定位',
        _title_default: '诏安法院-智慧定位',
      },
      {
        component: require('../404.js').default,
        _title: '诏安法院-智慧定位',
        _title_default: '诏安法院-智慧定位',
      },
    ],
    Author: 'DL',
    Date: '2020-12-03T09:53:55.000Z',
    Email: 'dunaliang@fengmap.com',
    LastEditTime: '2020-12-18T18:26:06.000Z',
    LastEditors: 'DL',
    Description: null,
    Copyright: 'Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.',
    _title: '诏安法院-智慧定位',
    _title_default: '诏安法院-智慧定位',
  },
];
window.g_routes = routes;
const plugins = require('umi/_runtimePlugin');
plugins.applyForEach('patchRoutes', { initialValue: routes });

export { routes };

export default class RouterWrapper extends React.Component {
  unListen() {}

  constructor(props) {
    super(props);

    // route change handler
    function routeChangeHandler(location, action) {
      plugins.applyForEach('onRouteChange', {
        initialValue: {
          routes,
          location,
          action,
        },
      });
    }
    this.unListen = history.listen(routeChangeHandler);
    // dva 中 history.listen 会初始执行一次
    // 这里排除掉 dva 的场景，可以避免 onRouteChange 在启用 dva 后的初始加载时被多执行一次
    const isDva =
      history.listen
        .toString()
        .indexOf('callback(history.location, history.action)') > -1;
    if (!isDva) {
      routeChangeHandler(history.location);
    }
  }

  componentWillUnmount() {
    this.unListen();
  }

  render() {
    const props = this.props || {};
    return <Router history={history}>{renderRoutes(routes, props)}</Router>;
  }
}
